import { DateTime } from "luxon";

import styled from "@mui/material/styles/styled";
import Typography, { TypographyProps } from "@mui/material/Typography";

import Button, { ButtonProps } from "@rui/Button";

export const TitleText = styled((props: TypographyProps) => (
  <Typography variant="bodyPrimaryReg" {...props} />
))(({ theme }) => ({
  color: theme.palette.shades.neutral[800],
  lineHeight: "1.25rem",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export const InfoText = styled((props: TypographyProps) => (
  <Typography variant="bodySecondaryReg" {...props} />
))(({ theme }) => ({
  fontSize: "0.875rem",
  color: theme.palette.shades.neutral[500],
  lineHeight: "1.125rem",
}));

export const EditButton = styled((props: ButtonProps) => (
  <Button variant="outlined" {...props} />
))(({ theme }) => ({
  color: theme.palette.shades.neutral[500],
  border: `1px solid ${theme.palette.shades.neutral[100]}`,
  height: "36px",
  padding: "8px 16px",
  borderRadius: "4px",
  fontSize: "0.875rem",

  "&:hover": {
    color: theme.palette.shades.neutral[500],
    border: `1px solid ${theme.palette.shades.primary[500]}`,
  },
}));

const NO_DATE = "No date or time";

export const DateText = styled(
  ({
    startTime,
    ...props
  }: TypographyProps & {
    startTime: DateTime | null;
  }) => {
    let text = NO_DATE;
    if (startTime) {
      const dateText = startTime.toLocaleString(DateTime.DATE_SHORT);
      const timeText = `${startTime.toLocaleString(DateTime.TIME_SIMPLE)}`;

      text = `${dateText} ${timeText}`;
    }

    return (
      <Typography variant="bodySecondaryReg" {...props}>
        {text}
      </Typography>
    );
  }
)(({ theme, startTime }) => ({
  color: theme.palette.shades.neutral[startTime ? 600 : 400],
  fontSize: "0.875rem",
  lineHeight: "1.125rem",
}));
